/* FLURR REWARDS — CONFETTI ON TIER UNLOCK */

window.flurrCelebrateRewards = function () {
  var drawer = document.getElementById('Cart-Drawer');
  if (!drawer) return;

  var rewards = drawer.querySelector('.flurr-rewards');
  if (rewards) {
    rewards.classList.remove('is-celebrating');
    void rewards.offsetWidth; // restart animation
    rewards.classList.add('is-celebrating');
  }

  var canvas = document.createElement('canvas');
  canvas.className = 'flurr-confetti';
  drawer.appendChild(canvas);

  var box = drawer.getBoundingClientRect();
  canvas.width = box.width;
  canvas.height = box.height;

  // burst from the progress bar
  var ox = canvas.width / 2;
  var oy = canvas.height * 0.2;
  if (rewards) {
    var r = rewards.getBoundingClientRect();
    oy = r.top - box.top + r.height / 2;
  }

  var ctx = canvas.getContext('2d');
  var colors = ['#ff5500', '#15b79e', '#ffd166', '#ef476f', '#118ab2', '#ffffff'];
  var pieces = [];

  for (var i = 0; i < 90; i++) {
    pieces.push({
      x: ox + (Math.random() - 0.5) * 80,
      y: oy,
      vx: (Math.random() - 0.5) * 14,
      vy: -Math.random() * 12 - 4,
      w: 6 + Math.random() * 6,
      h: 4 + Math.random() * 4,
      rot: Math.random() * Math.PI,
      vr: (Math.random() - 0.5) * 0.3,
      color: colors[i % colors.length]
    });
  }

  var duration = 1800;
  var start = null;

  function frame(ts) {
    if (!start) start = ts;
    var t = ts - start;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.globalAlpha = Math.max(0, 1 - t / duration);

    pieces.forEach(function (p) {
      p.vy += 0.35;
      p.vx *= 0.99;
      p.x += p.vx;
      p.y += p.vy;
      p.rot += p.vr;

      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    });

    if (t < duration) {
      requestAnimationFrame(frame);
    } else {
      canvas.remove();
    }
  }

  requestAnimationFrame(frame);
};